module.exports = __webpack_public_path__ + "img/main_tnbox_service_01_2.adbedc3c.svg";